export enum KnownColors {
    //
    // Summary:
    //     The system-defined color of the active window's border.
    ActiveBorder = 1,
    //
    // Summary:
    //     The system-defined color of the background of the active window's title bar.
    ActiveCaption = 2,
    //
    // Summary:
    //     The system-defined color of the text in the active window's title bar.
    ActiveCaptionText = 3,
    //
    // Summary:
    //     The system-defined color of the application workspace. The application workspace
    //     is the area in a multiple-document view that is not being occupied by documents.
    AppWorkspace = 4,
    //
    // Summary:
    //     The system-defined face color of a 3-D element.
    Control = 5,
    //
    // Summary:
    //     The system-defined shadow color of a 3-D element. The shadow color is applied
    //     to parts of a 3-D element that face away from the light source.
    ControlDark = 6,
    //
    // Summary:
    //     The system-defined color that is the dark shadow color of a 3-D element. The
    //     dark shadow color is applied to the parts of a 3-D element that are the darkest
    //     color.
    ControlDarkDark = 7,
    //
    // Summary:
    //     The system-defined color that is the light color of a 3-D element. The light
    //     color is applied to parts of a 3-D element that face the light source.
    ControlLight = 8,
    //
    // Summary:
    //     The system-defined highlight color of a 3-D element. The highlight color is applied
    //     to the parts of a 3-D element that are the lightest color.
    ControlLightLight = 9,
    //
    // Summary:
    //     The system-defined color of text in a 3-D element.
    ControlText = 10,
    //
    // Summary:
    //     The system-defined color of the desktop.
    Desktop = 11,
    //
    // Summary:
    //     The system-defined color of dimmed text. Items in a list that are disabled are
    //     displayed in dimmed text.
    GrayText = 12,
    //
    // Summary:
    //     The system-defined color of the background of selected items. This includes selected
    //     menu items as well as selected text.
    Highlight = 13,
    //
    // Summary:
    //     The system-defined color of the text of selected items.
    HighlightText = 14,
    //
    // Summary:
    //     The system-defined color used to designate a hot-tracked item. Single-clicking
    //     a hot-tracked item executes the item.
    HotTrack = 15,
    //
    // Summary:
    //     The system-defined color of an inactive window's border.
    InactiveBorder = 16,
    //
    // Summary:
    //     The system-defined color of the background of an inactive window's title bar.
    InactiveCaption = 17,
    //
    // Summary:
    //     The system-defined color of the text in an inactive window's title bar.
    InactiveCaptionText = 18,
    //
    // Summary:
    //     The system-defined color of the background of a ToolTip.
    Info = 19,
    //
    // Summary:
    //     The system-defined color of the text of a ToolTip.
    InfoText = 20,
    //
    // Summary:
    //     The system-defined color of a menu's background.
    Menu = 21,
    //
    // Summary:
    //     The system-defined color of a menu's text.
    MenuText = 22,
    //
    // Summary:
    //     The system-defined color of the background of a scroll bar.
    ScrollBar = 23,
    //
    // Summary:
    //     The system-defined color of the background in the client area of a window.
    Window = 24,
    //
    // Summary:
    //     The system-defined color of a window frame.
    WindowFrame = 25,
    //
    // Summary:
    //     The system-defined color of the text in the client area of a window.
    WindowText = 26,
    //
    // Summary:
    //     A system-defined color.
    Transparent = 27,
    //
    // Summary:
    //     A system-defined color.
    AliceBlue = 28,
    //
    // Summary:
    //     A system-defined color.
    AntiqueWhite = 29,
    //
    // Summary:
    //     A system-defined color.
    Aqua = 30,
    //
    // Summary:
    //     A system-defined color.
    Aquamarine = 31,
    //
    // Summary:
    //     A system-defined color.
    Azure = 32,
    //
    // Summary:
    //     A system-defined color.
    Beige = 33,
    //
    // Summary:
    //     A system-defined color.
    Bisque = 34,
    //
    // Summary:
    //     A system-defined color.
    Black = 35,
    //
    // Summary:
    //     A system-defined color.
    BlanchedAlmond = 36,
    //
    // Summary:
    //     A system-defined color.
    Blue = 37,
    //
    // Summary:
    //     A system-defined color.
    BlueViolet = 38,
    //
    // Summary:
    //     A system-defined color.
    Brown = 39,
    //
    // Summary:
    //     A system-defined color.
    BurlyWood = 40,
    //
    // Summary:
    //     A system-defined color.
    CadetBlue = 41,
    //
    // Summary:
    //     A system-defined color.
    Chartreuse = 42,
    //
    // Summary:
    //     A system-defined color.
    Chocolate = 43,
    //
    // Summary:
    //     A system-defined color.
    Coral = 44,
    //
    // Summary:
    //     A system-defined color.
    CornflowerBlue = 45,
    //
    // Summary:
    //     A system-defined color.
    Cornsilk = 46,
    //
    // Summary:
    //     A system-defined color.
    Crimson = 47,
    //
    // Summary:
    //     A system-defined color.
    Cyan = 48,
    //
    // Summary:
    //     A system-defined color.
    DarkBlue = 49,
    //
    // Summary:
    //     A system-defined color.
    DarkCyan = 50,
    //
    // Summary:
    //     A system-defined color.
    DarkGoldenrod = 51,
    //
    // Summary:
    //     A system-defined color.
    DarkGray = 52,
    //
    // Summary:
    //     A system-defined color.
    DarkGreen = 53,
    //
    // Summary:
    //     A system-defined color.
    DarkKhaki = 54,
    //
    // Summary:
    //     A system-defined color.
    DarkMagenta = 55,
    //
    // Summary:
    //     A system-defined color.
    DarkOliveGreen = 56,
    //
    // Summary:
    //     A system-defined color.
    DarkOrange = 57,
    //
    // Summary:
    //     A system-defined color.
    DarkOrchid = 58,
    //
    // Summary:
    //     A system-defined color.
    DarkRed = 59,
    //
    // Summary:
    //     A system-defined color.
    DarkSalmon = 60,
    //
    // Summary:
    //     A system-defined color.
    DarkSeaGreen = 61,
    //
    // Summary:
    //     A system-defined color.
    DarkSlateBlue = 62,
    //
    // Summary:
    //     A system-defined color.
    DarkSlateGray = 63,
    //
    // Summary:
    //     A system-defined color.
    DarkTurquoise = 64,
    //
    // Summary:
    //     A system-defined color.
    DarkViolet = 65,
    //
    // Summary:
    //     A system-defined color.
    DeepPink = 66,
    //
    // Summary:
    //     A system-defined color.
    DeepSkyBlue = 67,
    //
    // Summary:
    //     A system-defined color.
    DimGray = 68,
    //
    // Summary:
    //     A system-defined color.
    DodgerBlue = 69,
    //
    // Summary:
    //     A system-defined color.
    Firebrick = 70,
    //
    // Summary:
    //     A system-defined color.
    FloralWhite = 71,
    //
    // Summary:
    //     A system-defined color.
    ForestGreen = 72,
    //
    // Summary:
    //     A system-defined color.
    Fuchsia = 73,
    //
    // Summary:
    //     A system-defined color.
    Gainsboro = 74,
    //
    // Summary:
    //     A system-defined color.
    GhostWhite = 75,
    //
    // Summary:
    //     A system-defined color.
    Gold = 76,
    //
    // Summary:
    //     A system-defined color.
    Goldenrod = 77,
    //
    // Summary:
    //     A system-defined color.
    Gray = 78,
    //
    // Summary:
    //     A system-defined color.
    Green = 79,
    //
    // Summary:
    //     A system-defined color.
    GreenYellow = 80,
    //
    // Summary:
    //     A system-defined color.
    Honeydew = 81,
    //
    // Summary:
    //     A system-defined color.
    HotPink = 82,
    //
    // Summary:
    //     A system-defined color.
    IndianRed = 83,
    //
    // Summary:
    //     A system-defined color.
    Indigo = 84,
    //
    // Summary:
    //     A system-defined color.
    Ivory = 85,
    //
    // Summary:
    //     A system-defined color.
    Khaki = 86,
    //
    // Summary:
    //     A system-defined color.
    Lavender = 87,
    //
    // Summary:
    //     A system-defined color.
    LavenderBlush = 88,
    //
    // Summary:
    //     A system-defined color.
    LawnGreen = 89,
    //
    // Summary:
    //     A system-defined color.
    LemonChiffon = 90,
    //
    // Summary:
    //     A system-defined color.
    LightBlue = 91,
    //
    // Summary:
    //     A system-defined color.
    LightCoral = 92,
    //
    // Summary:
    //     A system-defined color.
    LightCyan = 93,
    //
    // Summary:
    //     A system-defined color.
    LightGoldenrodYellow = 94,
    //
    // Summary:
    //     A system-defined color.
    LightGray = 95,
    //
    // Summary:
    //     A system-defined color.
    LightGreen = 96,
    //
    // Summary:
    //     A system-defined color.
    LightPink = 97,
    //
    // Summary:
    //     A system-defined color.
    LightSalmon = 98,
    //
    // Summary:
    //     A system-defined color.
    LightSeaGreen = 99,
    //
    // Summary:
    //     A system-defined color.
    LightSkyBlue = 100,
    //
    // Summary:
    //     A system-defined color.
    LightSlateGray = 101,
    //
    // Summary:
    //     A system-defined color.
    LightSteelBlue = 102,
    //
    // Summary:
    //     A system-defined color.
    LightYellow = 103,
    //
    // Summary:
    //     A system-defined color.
    Lime = 104,
    //
    // Summary:
    //     A system-defined color.
    LimeGreen = 105,
    //
    // Summary:
    //     A system-defined color.
    Linen = 106,
    //
    // Summary:
    //     A system-defined color.
    Magenta = 107,
    //
    // Summary:
    //     A system-defined color.
    Maroon = 108,
    //
    // Summary:
    //     A system-defined color.
    MediumAquamarine = 109,
    //
    // Summary:
    //     A system-defined color.
    MediumBlue = 110,
    //
    // Summary:
    //     A system-defined color.
    MediumOrchid = 111,
    //
    // Summary:
    //     A system-defined color.
    MediumPurple = 112,
    //
    // Summary:
    //     A system-defined color.
    MediumSeaGreen = 113,
    //
    // Summary:
    //     A system-defined color.
    MediumSlateBlue = 114,
    //
    // Summary:
    //     A system-defined color.
    MediumSpringGreen = 115,
    //
    // Summary:
    //     A system-defined color.
    MediumTurquoise = 116,
    //
    // Summary:
    //     A system-defined color.
    MediumVioletRed = 117,
    //
    // Summary:
    //     A system-defined color.
    MidnightBlue = 118,
    //
    // Summary:
    //     A system-defined color.
    MintCream = 119,
    //
    // Summary:
    //     A system-defined color.
    MistyRose = 120,
    //
    // Summary:
    //     A system-defined color.
    Moccasin = 121,
    //
    // Summary:
    //     A system-defined color.
    NavajoWhite = 122,
    //
    // Summary:
    //     A system-defined color.
    Navy = 123,
    //
    // Summary:
    //     A system-defined color.
    OldLace = 124,
    //
    // Summary:
    //     A system-defined color.
    Olive = 125,
    //
    // Summary:
    //     A system-defined color.
    OliveDrab = 126,
    //
    // Summary:
    //     A system-defined color.
    Orange = 127,
    //
    // Summary:
    //     A system-defined color.
    OrangeRed = 128,
    //
    // Summary:
    //     A system-defined color.
    Orchid = 129,
    //
    // Summary:
    //     A system-defined color.
    PaleGoldenrod = 130,
    //
    // Summary:
    //     A system-defined color.
    PaleGreen = 131,
    //
    // Summary:
    //     A system-defined color.
    PaleTurquoise = 132,
    //
    // Summary:
    //     A system-defined color.
    PaleVioletRed = 133,
    //
    // Summary:
    //     A system-defined color.
    PapayaWhip = 134,
    //
    // Summary:
    //     A system-defined color.
    PeachPuff = 135,
    //
    // Summary:
    //     A system-defined color.
    Peru = 136,
    //
    // Summary:
    //     A system-defined color.
    Pink = 137,
    //
    // Summary:
    //     A system-defined color.
    Plum = 138,
    //
    // Summary:
    //     A system-defined color.
    PowderBlue = 139,
    //
    // Summary:
    //     A system-defined color.
    Purple = 140,
    //
    // Summary:
    //     A system-defined color.
    Red = 141,
    //
    // Summary:
    //     A system-defined color.
    RosyBrown = 142,
    //
    // Summary:
    //     A system-defined color.
    RoyalBlue = 143,
    //
    // Summary:
    //     A system-defined color.
    SaddleBrown = 144,
    //
    // Summary:
    //     A system-defined color.
    Salmon = 145,
    //
    // Summary:
    //     A system-defined color.
    SandyBrown = 146,
    //
    // Summary:
    //     A system-defined color.
    SeaGreen = 147,
    //
    // Summary:
    //     A system-defined color.
    SeaShell = 148,
    //
    // Summary:
    //     A system-defined color.
    Sienna = 149,
    //
    // Summary:
    //     A system-defined color.
    Silver = 150,
    //
    // Summary:
    //     A system-defined color.
    SkyBlue = 151,
    //
    // Summary:
    //     A system-defined color.
    SlateBlue = 152,
    //
    // Summary:
    //     A system-defined color.
    SlateGray = 153,
    //
    // Summary:
    //     A system-defined color.
    Snow = 154,
    //
    // Summary:
    //     A system-defined color.
    SpringGreen = 155,
    //
    // Summary:
    //     A system-defined color.
    SteelBlue = 156,
    //
    // Summary:
    //     A system-defined color.
    Tan = 157,
    //
    // Summary:
    //     A system-defined color.
    Teal = 158,
    //
    // Summary:
    //     A system-defined color.
    Thistle = 159,
    //
    // Summary:
    //     A system-defined color.
    Tomato = 160,
    //
    // Summary:
    //     A system-defined color.
    Turquoise = 161,
    //
    // Summary:
    //     A system-defined color.
    Violet = 162,
    //
    // Summary:
    //     A system-defined color.
    Wheat = 163,
    //
    // Summary:
    //     A system-defined color.
    White = 164,
    //
    // Summary:
    //     A system-defined color.
    WhiteSmoke = 165,
    //
    // Summary:
    //     A system-defined color.
    Yellow = 166,
    //
    // Summary:
    //     A system-defined color.
    YellowGreen = 167,
    //
    // Summary:
    //     The system-defined face color of a 3-D element.
    ButtonFace = 168,
    //
    // Summary:
    //     The system-defined color that is the highlight color of a 3-D element. This color
    //     is applied to parts of a 3-D element that face the light source.
    ButtonHighlight = 169,
    //
    // Summary:
    //     The system-defined color that is the shadow color of a 3-D element. This color
    //     is applied to parts of a 3-D element that face away from the light source.
    ButtonShadow = 170,
    //
    // Summary:
    //     The system-defined color of the lightest color in the color gradient of an active
    //     window's title bar.
    GradientActiveCaption = 171,
    //
    // Summary:
    //     The system-defined color of the lightest color in the color gradient of an inactive
    //     window's title bar.
    GradientInactiveCaption = 172,
    //
    // Summary:
    //     The system-defined color of the background of a menu bar.
    MenuBar = 173,
    //
    // Summary:
    //     The system-defined color used to highlight menu items when the menu appears as
    //     a flat menu.
    MenuHighlight = 174
}

export class KnownColor {
    static colors = {
        1: "180,180,180,255",
        2: "153,180,209,255",
        3: "0,0,0,255",
        4: "171,171,171,255",
        5: "240,240,240,255",
        6: "160,160,160,255",
        7: "105,105,105,255",
        8: "227,227,227,255",
        9: "255,255,255,255",
        10: "0,0,0,255",
        11: "0,0,0,255",
        12: "109,109,109,255",
        13: "51,153,255,255",
        14: "255,255,255,255",
        15: "0,102,204,255",
        16: "244,247,252,255",
        17: "191,205,219,255",
        18: "0,0,0,255",
        19: "255,255,225,255",
        20: "0,0,0,255",
        21: "240,240,240,255",
        22: "0,0,0,255",
        23: "200,200,200,255",
        24: "255,255,255,255",
        25: "100,100,100,255",
        26: "0,0,0,255",
        27: "255,255,255,0",
        28: "240,248,255,255",
        29: "250,235,215,255",
        30: "0,255,255,255",
        31: "127,255,212,255",
        32: "240,255,255,255",
        33: "245,245,220,255",
        34: "255,228,196,255",
        35: "0,0,0,255",
        36: "255,235,205,255",
        37: "0,0,255,255",
        38: "138,43,226,255",
        39: "165,42,42,255",
        40: "222,184,135,255",
        41: "95,158,160,255",
        42: "127,255,0,255",
        43: "210,105,30,255",
        44: "255,127,80,255",
        45: "100,149,237,255",
        46: "255,248,220,255",
        47: "220,20,60,255",
        48: "0,255,255,255",
        49: "0,0,139,255",
        50: "0,139,139,255",
        51: "184,134,11,255",
        52: "169,169,169,255",
        53: "0,100,0,255",
        54: "189,183,107,255",
        55: "139,0,139,255",
        56: "85,107,47,255",
        57: "255,140,0,255",
        58: "153,50,204,255",
        59: "139,0,0,255",
        60: "233,150,122,255",
        61: "143,188,139,255",
        62: "72,61,139,255",
        63: "47,79,79,255",
        64: "0,206,209,255",
        65: "148,0,211,255",
        66: "255,20,147,255",
        67: "0,191,255,255",
        68: "105,105,105,255",
        69: "30,144,255,255",
        70: "178,34,34,255",
        71: "255,250,240,255",
        72: "34,139,34,255",
        73: "255,0,255,255",
        74: "220,220,220,255",
        75: "248,248,255,255",
        76: "255,215,0,255",
        77: "218,165,32,255",
        78: "128,128,128,255",
        79: "0,128,0,255",
        80: "173,255,47,255",
        81: "240,255,240,255",
        82: "255,105,180,255",
        83: "205,92,92,255",
        84: "75,0,130,255",
        85: "255,255,240,255",
        86: "240,230,140,255",
        87: "230,230,250,255",
        88: "255,240,245,255",
        89: "124,252,0,255",
        90: "255,250,205,255",
        91: "173,216,230,255",
        92: "240,128,128,255",
        93: "224,255,255,255",
        94: "250,250,210,255",
        95: "211,211,211,255",
        96: "144,238,144,255",
        97: "255,182,193,255",
        98: "255,160,122,255",
        99: "32,178,170,255",
        100: "135,206,250,255",
        101: "119,136,153,255",
        102: "176,196,222,255",
        103: "255,255,224,255",
        104: "0,255,0,255",
        105: "50,205,50,255",
        106: "250,240,230,255",
        107: "255,0,255,255",
        108: "128,0,0,255",
        109: "102,205,170,255",
        110: "0,0,205,255",
        111: "186,85,211,255",
        112: "147,112,219,255",
        113: "60,179,113,255",
        114: "123,104,238,255",
        115: "0,250,154,255",
        116: "72,209,204,255",
        117: "199,21,133,255",
        118: "25,25,112,255",
        119: "245,255,250,255",
        120: "255,228,225,255",
        121: "255,228,181,255",
        122: "255,222,173,255",
        123: "0,0,128,255",
        124: "253,245,230,255",
        125: "128,128,0,255",
        126: "107,142,35,255",
        127: "255,165,0,255",
        128: "255,69,0,255",
        129: "218,112,214,255",
        130: "238,232,170,255",
        131: "152,251,152,255",
        132: "175,238,238,255",
        133: "219,112,147,255",
        134: "255,239,213,255",
        135: "255,218,185,255",
        136: "205,133,63,255",
        137: "255,192,203,255",
        138: "221,160,221,255",
        139: "176,224,230,255",
        140: "128,0,128,255",
        141: "255,0,0,255",
        142: "188,143,143,255",
        143: "65,105,225,255",
        144: "139,69,19,255",
        145: "250,128,114,255",
        146: "244,164,96,255",
        147: "46,139,87,255",
        148: "255,245,238,255",
        149: "160,82,45,255",
        150: "192,192,192,255",
        151: "135,206,235,255",
        152: "106,90,205,255",
        153: "112,128,144,255",
        154: "255,250,250,255",
        155: "0,255,127,255",
        156: "70,130,180,255",
        157: "210,180,140,255",
        158: "0,128,128,255",
        159: "216,191,216,255",
        160: "255,99,71,255",
        161: "64,224,208,255",
        162: "238,130,238,255",
        163: "245,222,179,255",
        164: "255,255,255,255",
        165: "245,245,245,255",
        166: "255,255,0,255",
        167: "154,205,50,255",
        168: "240,240,240,255",
        169: "255,255,255,255",
        170: "160,160,160,255",
        171: "185,209,234,255",
        172: "215,228,242,255",
        173: "240,240,240,255",
        174: "51,153,255,255"
    }

    static getColor(color: number | string): string {
        let e = KnownColors[color]
        if (isNaN(e))
            e = KnownColors[e]
        return this.colors[e]
    }
}